import React from 'react'
import PropTypes from 'prop-types'
import Link from 'next/link'
import * as S from './MobileRowItem.styled'
import ArrowRight from '../../../Icons/ArrowRight'
import { SkeletonPlaceholder } from 'src/shared/ui/skeleton/skeleton.styled'

const MobileRowItem = ({
    children,
    isShowedRow,
    isSelected,
    clickHandler,
    isLink,
    linkUrl,
    mouseDownHandler,
    aProps
}) => {
    const generateRowItem = () => (
        <S.Container role="row" onClick={clickHandler} onMouseDown={mouseDownHandler} {...aProps}>
            {children}
            <S.ExtendElements>
                {isSelected && <S.SelectedImage />}
                {isShowedRow && (
                    <S.ArrowContainer>
                        <ArrowRight />
                    </S.ArrowContainer>
                )}
            </S.ExtendElements>
        </S.Container>
    )

    if (linkUrl)
        return (
            <Link href={linkUrl} passHref legacyBehavior>
                {generateRowItem()}
            </Link>
        )
    return generateRowItem()
}

MobileRowItem.propTypes = {
    isShowedRow: PropTypes.bool,
    isSelected: PropTypes.bool.isRequired,
    clickHandler: PropTypes.func.isRequired,
    isLink: PropTypes.bool.isRequired,
    mouseDownHandler: PropTypes.func,
    linkUrl: PropTypes.string,
    aProps: PropTypes.any
}

MobileRowItem.defaultProps = {
    isShowedRow: false,
    isSelected: false,
    clickHandler: () => {},
    onMouseDown: () => {},
    isLink: false,
    aProps: null
}

export default MobileRowItem

export const MobileRowSkeleton = () => {
    return (
        <React.Fragment>
            <S.SkeletonContainer>
                <S.SkeletonContentContainer>
                    <S.SkeletonTitle>
                        <SkeletonPlaceholder />
                    </S.SkeletonTitle>
                    <S.SkeletonDescription>
                        <SkeletonPlaceholder />
                    </S.SkeletonDescription>
                </S.SkeletonContentContainer>
            </S.SkeletonContainer>
            <S.SkeletonContainer>
                <S.SkeletonContentContainer>
                    <S.SkeletonTitle>
                        <SkeletonPlaceholder />
                    </S.SkeletonTitle>
                    <S.SkeletonDescription>
                        <SkeletonPlaceholder />
                    </S.SkeletonDescription>
                </S.SkeletonContentContainer>
            </S.SkeletonContainer>
            <S.SkeletonContainer>
                <S.SkeletonContentContainer>
                    <S.SkeletonTitle>
                        <SkeletonPlaceholder />
                    </S.SkeletonTitle>
                    <S.SkeletonDescription>
                        <SkeletonPlaceholder />
                    </S.SkeletonDescription>
                </S.SkeletonContentContainer>
            </S.SkeletonContainer>
            <S.SkeletonContainer>
                <S.SkeletonContentContainer>
                    <S.SkeletonTitle>
                        <SkeletonPlaceholder />
                    </S.SkeletonTitle>
                    <S.SkeletonDescription>
                        <SkeletonPlaceholder />
                    </S.SkeletonDescription>
                </S.SkeletonContentContainer>
            </S.SkeletonContainer>
            <S.SkeletonContainer>
                <S.SkeletonContentContainer>
                    <S.SkeletonTitle>
                        <SkeletonPlaceholder />
                    </S.SkeletonTitle>
                    <S.SkeletonDescription>
                        <SkeletonPlaceholder />
                    </S.SkeletonDescription>
                </S.SkeletonContentContainer>
            </S.SkeletonContainer>
        </React.Fragment>
    )
}
